export default "__VITE_ASSET__7eb49954__"